import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Muted } from '../Controls';
import { Panel, PanelTitle } from '../Page';
import { checkPush, turnOffPush, turnOnPush } from './actions';
import { selectPushBusy, selectPushError, selectPushStatus } from './selectors';

/**
 * Turning on notifications for "It's your turn" and the like, in this browser or Home Screen app. On an iPhone they
 * only work from the Home Screen, so a browser tab says how to get there. Hidden while the server isn't set up.
 */
const PushSettings = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectPushStatus);
  const busy = useSelector(selectPushBusy);
  const error = useSelector(selectPushError);

  useEffect(() => {
    dispatch(checkPush());
  }, [dispatch]);

  if (status === null || status === 'server-off' || status === 'unsupported') {
    return null;
  }

  const body = {
    'add-to-home-screen': (
      <Muted>
        To get a notification when it&apos;s your turn, add this app to your Home Screen: tap Share, then Add to Home
        Screen, and open it from there.
      </Muted>
    ),
    blocked: <Muted>Notifications are turned off for this app in your settings.</Muted>,
    off: <Button $primary onClick={() => dispatch(turnOnPush())} disabled={busy}>Turn on notifications</Button>,
    on: (
      <>
        <Muted>You&apos;ll get a notification when it&apos;s your turn.</Muted>
        <Button onClick={() => dispatch(turnOffPush())} disabled={busy}>Turn off</Button>
      </>
    ),
  }[status];

  return (
    <Panel>
      <PanelTitle>Notifications</PanelTitle>
      {body}
      {error && <Muted role="alert">{error}</Muted>}
    </Panel>
  );
};

export default PushSettings;
